import { combineEpics } from 'redux-observable';
import { Observable } from 'rxjs';

import * as ActionTypes from '../../actions/ActionTypes';


// show/hide captions buttons based on video source
const toggleCaptionsButtonEpic = (action$, store, { player }) => action$
    .ofType(ActionTypes.RECEIVE_VIDEO_PLAYER_DATA)
    .map(() => store.getState().videoSource) // get video source state from store
    .do(videoSource => player.toggleClass('has-captions', videoSource.hasCaptions))
    .ignoreElements();


// add captions manually to menu select for captions embedded in live streams
const addCaptionsToMenuEpic = (action$, __, { player }) => action$
    .ofType(ActionTypes.PLAYER_EVENT_READY)
    .switchMap(() => Observable.fromEvent(player.tech_.el().textTracks, 'addtrack'))
    .filter(({ track }) => track.kind === 'captions')
    .do(({ track }) => player.tech_.remoteTextTracks().addTrack(track)) // attach embedded cea 708 captions to videojs menu controls
    .ignoreElements();


export default combineEpics(
    toggleCaptionsButtonEpic,
    addCaptionsToMenuEpic,
);



// WEBPACK FOOTER //
// ./src/ui/captions/epics.js